import {
  Box,
  Link,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Logo } from 'src/components/logo'
import { setTheme, setSEODetails, useCheckDomainQuery } from 'src/services/theme-service'
import { ForgetPasswordForm } from 'src/components/auth/forgetPasswordForm'
import { useDispatch } from 'react-redux'

const WhiteLabelForgetPassword = () => {
  let currentDomain
  if (typeof window !== 'undefined') {
    currentDomain = window.location.hostname
  }
  const navigate = useNavigate()
  const [whiteLabelTheme, setWhiteLabelTheme] = useState(null)
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up('md'))
  const { data: whiteLabelUser } = useCheckDomainQuery({ domain: currentDomain })

  useEffect(() => {
    setWhiteLabelTheme(whiteLabelUser?.data?.theme)
    if (whiteLabelUser?.data?.seo) {
      dispatch(setSEODetails({ ...whiteLabelUser?.data?.seo }))
      dispatch(setTheme({ ...whiteLabelUser?.data?.theme }))
    }
  }, [
    whiteLabelUser?.data?.theme,
    whiteLabelUser?.data?.seo
  ])

  const loginRedirect = () => {
    navigate('/w-login')
  }

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F2F4F6'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          width: isMdUp ? '500px' : '100%',
          height: '100%',
          p: 4,
          backgroundColor: theme.palette.background.default
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            width: '160px',
            height: '30px'
          }}
        >
          {whiteLabelTheme?.logo ? <img src={whiteLabelTheme?.logo} style={{ height: '36px', width: 'auto' }} /> : <Logo />}
        </Box>

        <ForgetPasswordForm
          whiteLabelTheme={whiteLabelTheme}
          onCancel={loginRedirect}
        />

        <Box>
          <Typography
            sx={{
              mt: 3,
              // fontFamily: "Noto Serif Vithkuqi, serif",
              color: `${theme.palette.primary.primaryText}`,
              fontSize: '13px',
              fontWeight: 500,
              lineHeight: '20px'
            }}
          >
            Don't have an account?
            <Link
              href='/w-register'
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  color: whiteLabelTheme?.colors ? whiteLabelTheme?.colors?.dark : theme.palette.primary.dark
                },
                color: whiteLabelTheme?.colors ? whiteLabelTheme?.colors?.main : theme.palette.primary.main,
                ml: 0.3,
                fontSize: '13px',
                fontWeight: 700,
                lineHeight: '20px'
              }}
            >
              Sign Up
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default WhiteLabelForgetPassword
